<template>
  <section>

     <Ver/>
     <VerReporte/>
    <h3 class="primary--text">
      <v-icon color="primary">people</v-icon>
      Vacaciones
    </h3>
    <v-card v-if="funcionario === null" elevation="0">
      <v-card-text class="text-md-center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
    
    </v-card>
    <v-card-text class="grey lighten-2 text--info">
      <v-layout wrap>
          <v-flex class="px-3">
            <v-btn
              icon
              color="primary"
              to="/listado-funcionarios-RRHH-vacaciones"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <strong>
              Vacaciones
            </strong>
          </v-flex>
        </v-layout>
    </v-card-text>
    <v-card>
      <v-card-text v-if="funcionario !== null" elevation="0">
        <p><strong>Nombre: </strong>{{ funcionario.nombre }} </p>
        <p><strong>Cédula: </strong>{{ funcionario.nro_doc }} </p>
        <p><strong>Fecha incorporación: </strong>{{ fecha_ingreso }}</p>
        <p><strong>Total saldo vacaciones: </strong>{{ saldo }} </p>
        <p><strong>Días a programar: </strong>{{ dias_a_programar }} </p>
        <p><strong> Saldo de vacación no utilizada: </strong>{{saldo_vacacion_no_usada }} </p>
      </v-card-text>
      <v-card-text>
        <crud-table
					:headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
					:graphql="graphql"
          :initData="initData"
				>
					<!-- Template injectable de la cabecera de la tabla -->
        	<template slot="buttons">
            
          </template>
					<!-- Template de filas y columnas -->
					<template slot="items" slot-scope="items">
						<!-- Agregar las columnas que consideré necesarias -->
             <td class="text-xs-center">{{items.item.fecha_desde }}</td>
            <td class="text-xs-center">{{ items.item.fecha_hasta}}</td>
            <td class="text-xs-center">{{ items.item.total_dias }}</td>
            <td class="text-xs-center">{{ items.item.estado}}</td>
            <td >
               <v-btn
                color="info"
                @click.prevent="ver(items.item)"
                icon
                title="Ver seguimiento"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>  
                <v-btn
                v-if="!items.item.id_padre"
               color="#f3cb19"
                @click.prevent="verReporte(items.item,0)"
                icon
                title="Ver reporte de programación de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>   
                <v-btn
                v-if="items.item.id_padre"
               color="#7b19d8"
                @click.prevent="verReporte(items.item,1)"
                icon
                title="Ver reporte de reprogramación de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>        
            </td>
          </template>

				</crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue'; // Componente Tabla Dinámica
import crud from '@/common/util/crud-table/mixins/crud-table'; // Funciones y Metodos
import Ver from "./dialogs/Ver";
import VerReporte from "./dialogs/VerReporte";

export default {
  	mixins: [crud],
  data() {
    let id_persona=parseInt(this.$route.params.id_persona);
    return {
      //active: "datos-personales-basicos",
      persona: null,
      loading: false,
      img_url: "",
      funcionario: null,
      fecha_ingreso: null,
      url: 'vVacaProgramadas',
			graphql: true,
      dias_a_programar:null,
      saldo_vacacion_no_usada:null,
			// Cabecera de la tabla
      initData: [
        {
          state: true,
          param: "id_persona",
          value: id_persona,
        },
      ],
			headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
         { text: "Fecha salida", value: "fecha_desde", align: "center" },
        { text: "Fecha fin", value: "fecha_hasta", align: "center" },
        // { text: "Tipo", value: "desc_tipo", align: "center" },      
       { text: "Dias", value: "total_dias", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			// Campos solicitados de Graphql(Agregar los que necesite)
			dataGraphql: `
       id
      id_persona
      id_estado
      fecha_desde
      fecha_hasta
      fecha_solicitud
      total_dias
      estado
      `,
			// Filtros del componente CrudTable ejemplo:
			// {
			// 	field: 'Campo definido en Graphql',
			// 	label: 'Etiqueta del input generado',
			// 	type: 'text', // Tipo de input en el filtro
			// 	typeG: 'String' // Tipo definido en Graphql
			// }
			filters: [
        {
          field: "fecha_desde",
          label: "Fecha salida",
          type: "text",
          typeG: "String",
        },
        {
          field: "fecha_hasta",
          label: "Fecha fin",
          type: "text",
          typeG: "String",
        },
       
         {
          field: "total_dias",
          label: "Dias",
          type: "number",
          typeG: "String",
        },
           {
          field: "estado",
          label: "Estado",
          type: "text",
          typeG: "String",
        },
      ],
      estado_vacacion: [],
      nombre:null,
      persona: null,
      saldo:null,
      periodo: null
      
	
    };
  },
  mounted() {
       this.onFilter();
     this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    //this.getImagen()
    this.verEstadoVacacion();
    this.obtenerDatos();
    
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    // if (this.$route.params.id) {
    //   this.obtenerPersona(this.$route.params.id)
    // } else {
    //   let user = this.$storage.get('user')
    //   this.obtenerPersona(user.id_persona)
    // }
    
  },
 
  methods: {
    verReporte(item,valor){
      item.reprogramacion=valor //programacion=0,repro=1
      this.$bus.$emit('openDialogVerReporte', item)
    },
    ver(item) {
      item.funcionario=this.funcionario
      item.saldo=this.saldo
      //console.log(item)
      this.$bus.$emit("openDialogVer", item);
    },

    async obtenerDatos () {
      let res = await this.$service.graphql({
        query: `
          query get($id: ID!){
            vListaPersonal(id: $id){
              nombre
              id_movilidad
              nro_doc
              
              item
              foto
              id_persona
              id_estado
              id_item
            }
          }
        `,
        variables: {
          id: this.$route.params.id_persona
        }
      })
      if (res.vListaPersonal.id_estado == 2) {
        this.$router.push('/401')
      }
      this.funcionario = res.vListaPersonal
      //console.log(this.funcionario)
     
    },


    async verEstadoVacacion() {
    let user = this.$storage.get("user");
 
        try {
          
        let res = await this.$service.graphql({
          query: `
							query{
                  vEstadoVacacions(id_persona:${parseInt(this.$route.params.id_persona)}){
                    rows{
                       nombre
                        dias_saldo
                        dias_asignados
                        dias_utilizados
                        dias_programados
                        dias_cta_vacacion
                        id
                        id_estado
                        id_persona
                        nombre
                        ingreso
                        gestion_desde
                        gestion_hasta
                        estado
                        cas
                        dias_a_programar
                        total_dias_saldo
                        saldo_a_programar
                    }
                  }
                } 
					`,
        });
        if (res.vEstadoVacacions.rows.length!=0) {
             this.estado_vacacion = res.vEstadoVacacions.rows;
          this.fecha_ingreso = this.estado_vacacion[0].ingreso;
        this.nombre=this.estado_vacacion[0].nombre;
        this.dias_a_programar=this.estado_vacacion[0].dias_a_programar;
        this.saldo_vacacion_no_usada=this.estado_vacacion[0].saldo_a_programar
        this.persona=this.estado_vacacion[0].id_persona;
        this.saldo=this.estado_vacacion[0].total_dias_saldo;
        }
       
      } catch (error) {
        console.log(error);
      }
    },
     
    
  },
  components: {
    CrudTable,
    Ver,
    VerReporte,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/admin/vacaciones/VacacionRRHH.vue